// Copyright (c) 2016 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import CheckboxFilterControlled from '../../../../shared/components/facets/checkbox-filter/controlled';
import FacetFooter from '../../../../shared/components/facets/facet-footer';
import Facets from '../../state/facets';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';

function handleDealerAccountFacetItem(item, isSelected) {

    this.actions.updateDealerAccountFacetItem(item, isSelected);

}

function handlePipTypeFacetItem(item, isSelected) {

    this.actions.updatePipTypeFacetItem(item, isSelected);

}

function handleApplyFilters() {

    this.actions.applySearchFilters(this);

}

function handleResetFilters() {

    this.actions.resetAllFacets(
        this.facets.dealerAccountsFacet.allowedDealers,
        this.facets.pipTypesFacet.allowedTypes
    );

}

function toggleDealerAccountFacetItems() {

    this.actions.toggleDealerAccountFacetItems(this.facets.dealerAccountsFacet.allowedDealers);

}

function togglePipTypeFacetItems() {

    this.actions.togglePipTypeFacetItems(this.facets.pipTypesFacet.allowedTypes);

}

const loadAllDealers = dealerAccountsFacet =>
    dealerAccountsFacet.isInitialLoad || dealerAccountsFacet.selectedDealers.length === 0;

class PipSearchFacets extends Component {

    state = {
        dealerLocationExpanded: false,
        pipTypesExpanded: false
    };

    componentWillMount() {

        if (loadAllDealers(this.props.facets.dealerAccountsFacet)) {

            this.props.actions.selectAllDealersOnInitialLoad(this.props.facets.dealerAccountsFacet.allowedDealers);

        }

        if (this.props.facets.pipTypesFacet.isInitialLoad) {

            this.props.actions.readFacetsData();

        }

        if (this.props.facets.pipTypesFacet.allowedTypes.length > 0) {

            this.props.actions.applySearchFilters(this.props);

        }

    }

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.pipTypesExpanded || this.state.dealerLocationExpanded;

    render() {

        return (
            <aside className='pip-search-facets'>
                {this.props.searchByType === 'PIN' &&
                    <CheckboxFilterControlled
                        canUseDefaultFormat={true}
                        initialState={createHashMap(this.props.facets.dealerAccountsFacet.selectedDealers, 'account')}
                        isExpanded={this.state.dealerLocationExpanded}
                        list={addCollectionLabels(this.props.facets.dealerAccountsFacet.allowedDealers)}
                        minNumberOfItems={4}
                        onChange={this.props::handleDealerAccountFacetItem}
                        onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                        onToggleAll={this.props::toggleDealerAccountFacetItems}
                        title='DEALER_ACCOUNTS'
                        valueKey='account'
                    />
                }
                <CheckboxFilterControlled
                    displayKey='value'
                    initialState={createHashMap(this.props.facets.pipTypesFacet.selectedTypes, 'key')}
                    isExpanded={this.state.pipTypesExpanded}
                    list={addCollectionLabels(this.props.facets.pipTypesFacet.allowedTypes, 'value')}
                    minNumberOfItems={4}
                    onChange={this.props::handlePipTypeFacetItem}
                    onClick={this.onAccordionToggle.bind(this, 'pipTypesExpanded')}
                    onToggleAll={this.props::togglePipTypeFacetItems}
                    title='PIP_TYPES'
                    valueKey='key'
                />
                {this.anyFacetsOpen() ?
                    <FacetFooter
                        disabled={this.props.facets.dealerAccountsFacet.selectedDealers.length === 0}
                        onApply={this.props::handleApplyFilters}
                        onReset={this.props::handleResetFilters}
                    /> : null}
            </aside>
        );

    }

}

PipSearchFacets.displayName = 'PipSearchFacets';
PipSearchFacets.propTypes = {
    actions: PropTypes.object.isRequired,
    facets: PropTypes.instanceOf(Facets).isRequired,
    searchByType: PropTypes.string.isRequired
};

export default PipSearchFacets;



// WEBPACK FOOTER //
// ./src/pip/pip-search/components/pip-search-facets/pip-search-facets-container.js